export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6368.f98b7c34.jpg";